// This assumes only one filter per key
export const toKey = (filter) => {
    return filter.id;
};
//# sourceMappingURL=util.js.map